import { Th } from "@itandi/itandi-bb-ui/Th";
import { Tr } from "@itandi/itandi-bb-ui/Tr";
import type { DealSortKey } from "~/models/Deal";

type Props = {
	handleSort: (selectedSortKey: DealSortKey) => () => Promise<void>;
	sortCondition: (sortKey: DealSortKey) => "asc" | "desc" | "none";
};
export function DealTableHeader({ sortCondition, handleSort }: Props) {
	return (
		<Tr>
			<Th
				onSort={handleSort("status_id")}
				sort={sortCondition("status_id")}
				width="7.5rem"
			>
				状況
			</Th>
			<Th>案件</Th>
			<Th textAlign="Center" width="4rem">
				残り
				<br />
				TODO
			</Th>
			<Th>自社担当者</Th>
			<Th>
				案件依頼先
				<br />
				担当者
			</Th>
			<Th
				onSort={handleSort("updated_date")}
				sort={sortCondition("updated_date")}
				width="4.5rem"
			>
				更新
				<br />
				日時
			</Th>
			<Th
				onSort={handleSort("termination_date")}
				sort={sortCondition("termination_date")}
				width="4.5rem"
			>
				解約日
			</Th>
			<Th
				onSort={handleSort("inspection_date")}
				sort={sortCondition("inspection_date")}
				width="4.6rem"
			>
				立会
				<br />
				日程
			</Th>
			<Th
				onSort={handleSort("survey_date")}
				sort={sortCondition("survey_date")}
				width="4.5rem"
			>
				現調
				<br />
				日程
			</Th>
			<Th
				onSort={handleSort("send_estimate_date")}
				sort={sortCondition("send_estimate_date")}
				width="4.5rem"
			>
				見積
				<br />
				提出日
			</Th>
			<Th
				onSort={handleSort("order_date")}
				sort={sortCondition("order_date")}
				width="4.5rem"
			>
				発注日
			</Th>
			<Th
				onSort={handleSort("construction_start_date")}
				sort={sortCondition("construction_start_date")}
				width="4.5rem"
			>
				工期
				<br />
				開始
			</Th>
			<Th
				onSort={handleSort("construction_end_date")}
				sort={sortCondition("construction_end_date")}
				width="4.5rem"
			>
				完工
				<br />
				予定日
			</Th>
			<Th
				onSort={handleSort("construction_reported_date")}
				sort={sortCondition("construction_reported_date")}
				width="4.5rem"
			>
				検収
				<br />
				依頼日
			</Th>
			<Th
				onSort={handleSort("completed_date")}
				sort={sortCondition("completed_date")}
				width="4.5rem"
			>
				完了日
			</Th>
			<Th
				onSort={handleSort("preferred_date")}
				sort={sortCondition("preferred_date")}
				width="4.5rem"
			>
				入居
				<br />
				予定日
			</Th>
			<Th
				onSort={handleSort("registration_date")}
				sort={sortCondition("registration_date")}
				width="4.5rem"
			>
				登録日
			</Th>
		</Tr>
	);
}
